import { updateStates } from '@/utils/reducer';
import {
  CREATE_TAG,
  CREATE_TAG_SUCCESS,
  DELETE_TAG,
  DELETE_TAG_SUCCESS,
  GET_TAG,
  GET_TAG_SUCCESS,
  GET_TAGS,
  GET_TAGS_SUCCESS,
  UPDATE_TAG,
  UPDATE_TAG_SUCCESS,
} from '@/store/types/tag';

const initState = {
  isLoading: true,
  isUpdating: false,
  list: [],
  listMetadata: {},
  item: {},
};

const reducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TAGS:
    case GET_TAG:
      return updateStates(state, { isLoading: true });
    case UPDATE_TAG:
    case DELETE_TAG:
    case CREATE_TAG:
      return updateStates(state, { isUpdating: true });
    case GET_TAG_SUCCESS:
      return updateStates(state, { item: payload, isLoading: false });
    case GET_TAGS_SUCCESS:
      return updateStates(state, {
        list: payload.data,
        listMetadata: payload.metadata,
        isLoading: false,
      });
    case DELETE_TAG_SUCCESS:
    case CREATE_TAG_SUCCESS:
      return updateStates(state, { isUpdating: false });
    case UPDATE_TAG_SUCCESS:
      return updateStates(state, { item: { ...state.item, ...action.payload }, isUpdating: false });

    default:
      return state;
  }
};

export default reducer;
